(function () {
  if (typeof window === 'undefined' || !window.FoxTheme || !window.FoxTheme.Carousel) return;

  const sliderRegistry = new WeakMap();
  const scrollLockState = {
    locked: false,
    lockCount: 0,
    scrollY: 0,
  };

  const lockPageScroll = () => {
    scrollLockState.lockCount += 1;
    if (scrollLockState.locked) return;

    scrollLockState.locked = true;
    scrollLockState.scrollY = window.scrollY || 0;

    document.documentElement.classList.add('store-location-modal-open');
    document.body.classList.add('store-location-modal-open');

    // Evita “scroll do fundo” em mobile + mantém posição ao fechar
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollLockState.scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  const unlockPageScroll = () => {
    scrollLockState.lockCount = Math.max(0, scrollLockState.lockCount - 1);
    if (!scrollLockState.locked || scrollLockState.lockCount > 0) return;

    document.documentElement.classList.remove('store-location-modal-open');
    document.body.classList.remove('store-location-modal-open');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(0, scrollLockState.scrollY);
    scrollLockState.scrollY = 0;
    scrollLockState.locked = false;
  };

  const initSlider = (modalElement) => {
    if (!modalElement || sliderRegistry.has(modalElement)) return;

    const sliderRoot = modalElement.querySelector('.store-location-modal__slider.swiper');
    if (!sliderRoot) return;

    const slideCount = parseInt(sliderRoot.dataset.slideCount || '0', 10);
    if (slideCount < 2) return;

    const maxVisibleSlides = 3;
    const desktopSlidesPerView = Math.min(slideCount, maxVisibleSlides);

    const sliderOptions = {
      slidesPerView: desktopSlidesPerView,
      spaceBetween: 12,
      loop: false,
      centeredSlides: false,
      grabCursor: true,
      navigation: {
        nextEl: modalElement.querySelector('.swiper-button-next'),
        prevEl: modalElement.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: modalElement.querySelector('.store-location-modal__pagination'),
        clickable: true,
      },
      autoHeight: false,
      breakpoints: {
        0: {
          // Mobile: 1 slide inteiro + “peek” do próximo (arrastar para ver o restante)
          slidesPerView: 1.18,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: desktopSlidesPerView,
        },
      },
      threshold: 2,
    };

    const sliderInstance = new window.FoxTheme.Carousel(sliderRoot, sliderOptions);
    sliderInstance.init();
    sliderRegistry.set(modalElement, sliderInstance);
  };

  const refreshSlider = (modalElement) => {
    const sliderInstance = sliderRegistry.get(modalElement);
    if (!sliderInstance || !sliderInstance.slider) return;
    sliderInstance.slider.update();
  };

  document.addEventListener('modal:handleAfterShow', (event) => {
    const modalElement = event.target;
    if (!modalElement || !modalElement.classList.contains('store-location-modal')) return;
    initSlider(modalElement);
    refreshSlider(modalElement);
    lockPageScroll();
  });

  document.addEventListener('modal:handleAfterHide', (event) => {
    const modalElement = event.target;
    if (!modalElement || !modalElement.classList.contains('store-location-modal')) return;
    unlockPageScroll();
  });
})();
